<template>
  <b-nav-item-dropdown>
    <template slot="button-content">
      <span class="nav-large">
        <font-awesome-icon :icon="['fas', 'external-link-alt']" />
        {{ $t('Webportal.ExternalTools') }}
      </span>
      <span class="nav-small" v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Edeka.ExternalTools.AnUndAbmeldeTool')">
        <font-awesome-icon :icon="['fas', 'external-link-alt']" />
      </span>
    </template>
    <b-dropdown-item :href="`https://go.msmiq.com/edeka/account/login.aspx?uid=${userProfile.login_name}`" target="_blank">
      {{ $t('Webportal.Edeka.ExternalTools.AnUndAbmeldeTool') }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default {
  name: "ExternalTools",

  mixins: [ AppConfig ],

  computed: {
    userProfile: function() {
      return AuthenticationService.userProfile;
    },
  }
}
</script>
